import { Button, makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles({
  root: {
    borderRadius: 50,
    color: "#101010",
    backgroundColor: "#2BF2AF",

    padding: "10px 25px",
    position: "relative",
    transition: "all 0.1s ease-in-out",
    "&:hover": {
      cursor: "pointer",
      color: "#505050",
      backgroundColor: "#6BF0AE",
    },
  },
});

function CustomButton({ text }) {
  const classes = useStyles();
  return <Button className={[classes.root]}>{text}</Button>;
}

export default CustomButton;
